import React from "react"
import Message from "../ui/Message"
import { User, DisplayMessage } from "../../ZeefTypes"

interface ZeefMessagesAreaProps {
  messages: DisplayMessage[]
  isLoadingMessages: boolean
  currentUser: User | null
  showMessageIdentifiers: boolean
  filteredIdentifierMap: Map<string, string>
  onReplyClick: (message: DisplayMessage) => void
  calculateThreadDepths: (messages: DisplayMessage[]) => Map<string, number>
}

const ZeefMessagesArea: React.FC<ZeefMessagesAreaProps> = ({
  messages,
  isLoadingMessages,
  currentUser,
  showMessageIdentifiers,
  filteredIdentifierMap,
  onReplyClick,
  calculateThreadDepths,
}) => {
  const hasMessages = messages.length > 0

  if (isLoadingMessages) {
    return (
      <div className="messages-content empty">
        <div className="welcome-message">
          <h3>Loading messages...</h3>
          <p>Please wait while we load your conversation history.</p>
        </div>
      </div>
    )
  }

  if (!hasMessages) {
    return (
      <div className="messages-content empty">
        <div className="welcome-message">
          <h3>Welcome to ZEEF!</h3>
          <p>Start a conversation by typing a message below.</p>
          {currentUser && (
            <p>
              You&apos;re logged in as <strong>{currentUser.username}</strong>
            </p>
          )}
        </div>
      </div>
    )
  }

  // Calculate thread depths for all messages
  const threadDepths = calculateThreadDepths(messages)

  return (
    <div className={`messages-content ${showMessageIdentifiers ? "show-identifiers" : ""}`}>
      {messages.map((message, index) => {
        const messageId = (message as any).serverId || message.id
        const threadDepth = threadDepths.get(messageId) || 0
        const identifier = filteredIdentifierMap.get(message.id)
        const hasIdentifier = showMessageIdentifiers && identifier !== undefined

        return (
          <Message
            key={message.id || index}
            message={message}
            currentUser={currentUser}
            index={index}
            threadDepth={threadDepth}
            onReplyClick={onReplyClick}
            identifier={identifier}
            showIdentifier={hasIdentifier}
          />
        )
      })}
    </div>
  )
}

export default ZeefMessagesArea
